import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col items-center justify-center w-ful my-5" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UseIcon = _resolveComponent("UseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.feedback) = $event)),
      name: "",
      id: "",
      cols: "30",
      rows: "10",
      class: "w-full rounded-lg border-2 border-gray-300 border-solid h-24 p-2 resize-none focus:outline-none"
    }, null, 512), [
      [_vModelText, _ctx.state.feedback]
    ]),
    _createElementVNode("button", {
      type: "submit",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitFeedback && _ctx.submitFeedback(...args))),
      disabled: _ctx.submitButtonIsDisabled,
      class: _normalizeClass([{
                'opacity-50': _ctx.state.isLoading,
                'opacity-50 bg-gray-100 text-gray-500': _ctx.submitButtonIsDisabled,
                'bg-brand-main text-white': !_ctx.submitButtonIsDisabled,
            }, "rounded-lg font-black mt-3 flex flex-col justify-center items-center py-2 w-full cursor-pointer focus:outline-none transition-all duration-200"])
    }, [
      (_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_UseIcon, {
            key: 0,
            name: "IconLoading",
            color: "white",
            class: "animate-spin"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Enviar feedback")
          ], 64))
    ], 10, _hoisted_2)
  ]))
}